module.exports = __webpack_public_path__ + "img/plan_top_separate.dee1a578.svg";